import React, {useState} from 'react';
import { Chat, Channel, ChannelHeader, Window, MessageList, MessageInput, MessageTeam, ReactionsList, MessageInputSmall, Thread  } from 'stream-chat-react';
import ReactGA from 'react-ga4';

const RPMStreamChat = ({...props}) =>
  {

    const onSendMessage = () => {
      ReactGA.event({
        category: "Message",
        action: "Message Sent",
      });
    };
    //doSendMessageRequest={onSendMessage}
   
    return (
      <div className="rpm-stream-chat bg-gray-500 absolute h-full w-full" >
        <Chat client={props.chatClient} theme={'livestream light'} >
          <Channel channel={props.chatChannel} Message={MessageTeam} ReactionsList={ReactionsList} >
            <Window hideOnThread>
              <MessageList />              
              <MessageInput />
            </Window>
            <Thread autoFocus={false} />
          </Channel>    
        </Chat>
      </div>
    )
  }

export default RPMStreamChat;